module.exports = __webpack_public_path__ + "static/media/shopify-partners-logo.26f4a152.png";